import {Component, OnInit, ViewChild} from '@angular/core';
import {NgForm} from "@angular/forms";
import {ActivatedRoute, Router} from "@angular/router";
import {DropDownFilterSettings} from "@progress/kendo-angular-dropdowns";
import {UploadContatosCampanhaComponent} from "../marketing/upload-contatos-campanha/upload-contatos-campanha.component";
import {CampanhaService} from "../services/campanha.service";
import {ContatosService} from "../services/contatos.service";
import {UsuarioService} from "../services/usuario.service";
import {AutorizacaoService} from "../services/autorizacao.service";
import {FiltroTelaUI} from "../../../projects/loja/src/objeto/FiltroTelaUI";

@Component({
  selector: 'app-nova-campanha-template',
  templateUrl: './nova-campanha-template.component.html',
  styleUrls: ['./nova-campanha-template.component.scss']
})
export class NovaCampanhaTemplateComponent implements OnInit {
  @ViewChild('frmCampanha', {static: false}) frmCampanha: NgForm;
  @ViewChild('uploadContatos', {static: false}) uploadContatos: UploadContatosCampanhaComponent;

  public filterSettings: DropDownFilterSettings = {
    caseSensitive: false,
    operator: 'contains'
  };

  campanha: any = {
    id: null,
    nome: '',
    mensagem: '',
    status: 'Nova',
    filtro: null,
    tipoDeEnvio: 'Unico',
    origemContatos: 'Filtro',
    files: [],
    contatos: [],
    inserirLinkDesinscrever: false,
    limitarQtdeContatos: false,
    qtdeContatosEnviarMsg: 250,
    naoEnviarMsgParaQuemRecebeuRecente: true,
    qtdeDiasUltimaNotificacao: 7,
    temMenu: false,
    menu: '',
    templateApiOficial: true
  };

  templates: Array<any> = [];
  templatesFiltrados: Array<any> = [];
  templateSelecionado: any;
  filtros: Array<any> = [];
  contatos: Array<any> = [];
  resumo: any = null;
  paginacao: any = {totalPorPagina: 5, pagina: 1, total: 0};
  carregandoTela = true;
  carregandoContatos = false;
  salvando = false;
  enviando = false;
  mostrarValidacoes = false;
  mensagemErro: any;
  mensagemSucesso: string;
  timer: any;
  empresa: any;
  numeroWhatsappCampanhas: any;

  constructor(private router: Router,
              private route: ActivatedRoute,
              private campanhaService: CampanhaService,
              private contatoService: ContatosService,
              private usuarioService: UsuarioService,
              private autorizacaoService: AutorizacaoService) {
  }

  ngOnInit(): void {
    this.empresa = this.autorizacaoService.getUser().empresa;
    this.numeroWhatsappCampanhas = this.empresa?.numeroWhatsappCampanhas || this.empresa?.numeroWhatsapp;

    Promise.all([
      this.campanhaService.obtenhaTemplatesMarketingAprovados(),
      this.usuarioService.listeFiltros()
    ]).then((respostas: any[]) => {
      this.templates = respostas[0].templates || [];
      this.templatesFiltrados = this.templates.slice();
      this.filtros = respostas[1] || [];
      this.mensagemErro = respostas[0].erroSincronizacaoMeta || null;

      this.route.params.subscribe(params => {
        const id = +params['idc'];
        if (!id) {
          this.carregandoTela = false;
          this.filtreContatos();
          return;
        }

        this.campanhaService.obtenhaCampanha(id).then((campanha: any) => {
          this.campanha = campanha;
          this.contatos = campanha.contatos || [];
          this.templateSelecionado = this.templates.find(t => t.id === campanha.cloudWhatsappTemplateId);
          this.carregandoTela = false;
          this.filtreContatos();
        });
      });
    }).catch((erro) => {
      this.carregandoTela = false;
      this.mensagemErro = erro;
    });
  }

  voltar() {
    this.router.navigateByUrl('/admin/marketing').then(() => {});
  }

  filtreTemplates(texto: string) {
    const termo = String(texto || '').toLowerCase();
    this.templatesFiltrados = this.templates.filter(template => {
      return String(template.nomeTemplate || '').toLowerCase().indexOf(termo) >= 0 ||
        String(template.textoMensagem || '').toLowerCase().indexOf(termo) >= 0 ||
        String(template.tipoNotificacao || '').toLowerCase().indexOf(termo) >= 0 ||
        String(template.origemTemplate || '').toLowerCase().indexOf(termo) >= 0;
    });
  }

  mudouTemplate() {
    this.campanha.cloudWhatsappTemplateId = this.templateSelecionado?.id || null;
    this.campanha.mensagem = this.templateSelecionado?.textoMensagem || '';
  }

  mudouOrigemContatos() {
    this.resumo = null;
    this.contatos = [];

    if (this.campanha.origemContatos === 'Filtro' && this.campanha.filtro) {
      this.filtreContatos();
    }

    if (this.campanha.origemContatos === 'Todos') {
      this.filtreContatos();
    }
  }

  mudouQtdeMensagensAEnviar() {
    if (this.timer) clearTimeout(this.timer);

    this.timer = setTimeout(() => {
      this.filtreContatos();
    }, 600);
  }

  filtreContatos() {
    if (this.campanha.origemContatos === 'Arquivo') {
      this.resumo = {total: this.contatos.length};
      return;
    }

    if (this.campanha.origemContatos === 'Filtro' && !this.campanha.filtro) {
      this.resumo = null;
      this.contatos = [];
      return;
    }

    this.carregandoContatos = true;
    const params = this.getParamsFiltro();

    this.contatoService.listeContatosDaCampanha(this.campanha, 0, this.paginacao.totalPorPagina, params).then((respContatos: any) => {
      this.contatos = respContatos.contatos || [];

      this.contatoService.obtenhaResumo(params).then(resumo => {
        this.resumo = resumo;
        this.paginacao.total = this.resumo.total;
        this.carregandoContatos = false;
      });
    }).catch((erro) => {
      this.carregandoContatos = false;
      this.mensagemErro = erro;
    });
  }

  getParamsFiltro() {
    let params: any = {};

    if (this.campanha.origemContatos === 'Filtro' && this.campanha.filtro) {
      params = FiltroTelaUI.getParamsRequest(this.campanha.filtro.dados);
    }

    params.marketingAtivo = true;
    params.qtdeDiasUltimaNotificacao = this.campanha.qtdeDiasUltimaNotificacao;
    params.naoEnviarMsgParaQuemRecebeuRecente = this.campanha.naoEnviarMsgParaQuemRecebeuRecente;

    return params;
  }

  usuarioFezUploadContatos(contatos: Array<any>) {
    this.contatos = contatos;
    this.resumo = {total: contatos.length};
  }

  deveMostrarValidacao() {
    return this.mostrarValidacoes || !!this.frmCampanha?.submitted;
  }

  erroContatosObrigatorios() {
    if (this.campanha.origemContatos === 'Arquivo') {
      return !this.arquivoContatosSelecionado() && !this.campanhaTemContatosArquivoSalvos();
    }

    if (this.campanha.origemContatos === 'Filtro') {
      return !this.campanha.filtro;
    }

    return this.resumo !== null && this.resumo.total === 0;
  }

  arquivoContatosSelecionado() {
    return this.campanha.files && this.campanha.files.length > 0;
  }

  campanhaTemContatosArquivoSalvos() {
    return !!this.campanha.id && this.contatos && this.contatos.length > 0;
  }

  arquivoSelecionadoSemContatosValidos() {
    return this.campanha.origemContatos === 'Arquivo' &&
      this.arquivoContatosSelecionado() &&
      (!this.contatos || this.contatos.length === 0);
  }

  salve(exigirTemplate = false) {
    this.mostrarValidacoes = true;
    this.mensagemErro = null;

    if (this.frmCampanha && !this.frmCampanha.valid) {
      this.mensagemErro = 'Preencha os dados obrigatórios da campanha.';
      return Promise.reject(this.mensagemErro);
    }

    if (exigirTemplate && !this.templateSelecionado) {
      this.mensagemErro = 'Selecione um template aprovado.';
      return Promise.reject(this.mensagemErro);
    }

    if (this.campanha.origemContatos === 'Arquivo' &&
      !this.arquivoContatosSelecionado() &&
      !this.campanhaTemContatosArquivoSalvos()) {
      this.mensagemErro = 'Envie um arquivo com contatos para criar a campanha.';
      return Promise.reject(this.mensagemErro);
    }

    if (this.arquivoSelecionadoSemContatosValidos()) {
      this.mensagemErro = 'O arquivo foi selecionado, mas nenhum contato válido foi encontrado. Use o id de um contato existente ou um telefone já cadastrado.';
      return Promise.reject(this.mensagemErro);
    }

    if (this.campanha.origemContatos === 'Todos' && this.resumo !== null && this.resumo.total === 0) {
      this.mensagemErro = 'Não há contatos disponíveis para enviar esta campanha.';
      return Promise.reject(this.mensagemErro);
    }

    const campanhaSalvar = Object.assign({}, this.campanha);
    campanhaSalvar.cloudWhatsappTemplateId = this.templateSelecionado?.id || null;
    campanhaSalvar.templateApiOficial = true;
    campanhaSalvar.mensagem = this.templateSelecionado?.textoMensagem || '';
    delete campanhaSalvar.contatos;

    this.salvando = true;

    return this.campanhaService.salveCampanhaTemplate(campanhaSalvar).then((resp: any) => {
      this.campanha.id = resp.id;
      this.campanha.cloudWhatsappTemplateId = this.templateSelecionado?.id || null;
      this.mensagemSucesso = 'Campanha salva com sucesso.';
      this.salvando = false;
      return resp;
    }).catch((erro) => {
      this.salvando = false;
      this.mensagemErro = erro;
      return Promise.reject(erro);
    });
  }

  apenasSalvar() {
    this.salve().then(() => {
      this.router.navigateByUrl('/admin/marketing').then(() => {});
    }).catch(() => {});
  }

  enviarCampanha() {
    this.salve(true).then((resp: any) => {
      this.enviando = true;
      const idCampanha = this.campanha.id || resp.id;
      this.campanhaService.inicieEnvioTemplate(idCampanha).then(() => {
        this.enviando = false;
        this.campanha.status = 'Enviando';
        this.mensagemSucesso = 'Campanha enviada para a fila de envio.';
      }).catch((erro) => {
        this.enviando = false;
        this.mensagemErro = erro;
      });
    }).catch(() => {});
  }

  obtenhaPreviewTemplate() {
    return {
      mensagem: this.templateSelecionado?.textoMensagem || '',
      textoSecao: '',
      temMenu: false,
      menu: {
        textoSecao: '',
        tituloMensagem: '',
        textoBotao: '',
        opcoes: []
      }
    };
  }
}
